import { loadFooterData } from '@/services';

import { Footer } from './Footer';

export async function FooterData() {
  const footerData = await loadFooterData();

  return (
    <Footer
      footerText={footerData?.footerText ?? ''}
      whitelabelAboutUs={footerData?.whitelabelAboutUs ?? ''}
      privacyPolicyLink={footerData?.privacyPolicyLink ?? ''}
      capitalizerLink={footerData?.capitalizerLink ?? ''}
      wlName={footerData?.wlName ?? ''}
      ilotoLink={footerData?.ilotoLink ?? ''}
      benefitedInstitution={footerData?.benefitedInstitution ?? ''}
      termsOfUseLink={footerData?.termsOfUseLink ?? ''}
      generalConditionsLink={footerData?.generalConditionsLink ?? ''}
      responsibleGamingLink={footerData?.responsibleGamingLink ?? ''}
      instagramUrl={footerData?.instagramUrl ?? ''}
      benefited={footerData?.benefited}
      capitalizer={footerData?.capitalizer}
    />
  );
}
